<template>
    <div id="menulist">
            <el-row>
                <el-col :span="18" v-if="this.currentMenuOperations.some(func => func.name.includes('menu_add'))">
                    <el-button type="primary" @click="addMenu">添加菜单</el-button>
                </el-col>
            </el-row>
            <div>
                <el-table :data="tables"
                    row-key="id"
                    :tree-props="{children: 'childrenList', hasChildren: 'hasChildren'}"
                    :row-class-name="tableRowClassName">
                  <el-table-column label="ID" prop="id"></el-table-column>
                    <el-table-column label="菜单名称" prop="name">
                        <template slot-scope="scope">
                            <a style="cursor:pointer;" @click="showOperation(scope.row, scope.$index)">{{scope.row.name}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="路由" prop="route"></el-table-column>
                    <el-table-column label="创建时间" prop="createTime">
                        <template slot-scope="scope">
                            {{new Date(scope.row.createTime).Format('yyyy/MM/dd hh:mm:ss')}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="300px"
                        v-if="listOperations.length > 0">
                        <template slot-scope="scope">
                            <el-button class="btnList" v-for="btn in listOperations" :key="btn.name"
                                size="mini"
                                :type="btn.name.includes('del') ? 'danger' : 'primary'"
                                @click="go(btn, scope.row, scope.$index)">
                                {{btn.alias}}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        <!-- </el-card> -->

        <menu-add v-if="showMenuAdd" :visible="showMenuAdd"
            :menu="selectMenu"
            :menuList="tables"
            @menuAddCallback="menuAddCallback"/>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { Loading } from "element-ui"
import MenuAdd from './MenuAdd'
export default {
    components: { MenuAdd },
    data: vm=>({
        tables: [],
        search: null,
        showMenuAdd: false,
        selectMenu: null,
        parentId: '',
        currentRowIndex: -1, // 当前选中的行
    }),
    created(){
        this.getListOperations('menu')
        if(!this.currentMenu){
            return
        }
        this.getList()
    },
    computed: {
       ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    },
    methods: {
        ...mapMutations(['getListOperations']),
        go(btn, row, index){
            this[btn.name](row, index)
        },
        tableRowClassName(row){
            if(this.currentRowIndex == row.rowIndex){
                return 'success-row'
            }else{
                return ''
            }
        },
        // 移动：上移up, 下移down
        menu_up(row,index){
        // changeRankUp(row, index){
            const rowindex = row.index
            if(rowindex == 0){
                this.$message.warning('已经是最顶端了，不能上移了哦')
                return
            }
            let idStr = '/'
            let arr = []
            // idStr = idStr + this.tables[index].id + '/' + this.tables[index - 1].id
            if(!row.uiParent){
                arr = this.tables
            }else{
                arr = this.tables.filter(tr => tr.id == row.uiParent)[0].childrenList
            }
            idStr = idStr + arr[rowindex].id + '/' + arr[rowindex - 1].id
            this.changeRank(idStr)
        },
        // changeRankDown(row, index){
        menu_down(row, index){
            const rowindex = row.index;
            if(rowindex == row.len - 1){
                this.$message.warning('已经是最底端了，不能下移了哦');
                return
            }
            let idStr = '/';
            let arr = [];
            // idStr = idStr + this.tables[index].id + '/' + this.tables[index + 1].id
            if(!row.uiParent){
                arr = this.tables
            }else{
                arr = this.tables.filter(tr => tr.id == row.uiParent)[0].childrenList
            }
            idStr = idStr + arr[rowindex].id + '/' + arr[rowindex + 1].id
            this.changeRank(idStr)
        },
        changeRank(idStr){
            // let idStr = '/'
            // if(type == 'up'){
            //     idStr = idStr + this.tables[index].id + '/' + this.tables[index - 1].id
            // }else{
            //     idStr = idStr + this.tables[index].id + '/' + this.tables[index + 1].id
            // }
            this.$axios.get(this.baseUrl3 + 'app/changeRank' + idStr)
            .then(({data:{data, msg, code}})=>{
                if(code == 20000){
                    this.getList();
                    this.$message.success('操作成功')
                }else{
                    this.$message.error('操作失败：' + msg)
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        getList(){
            let loading = Loading.service({
                fullscreen: true,
                text: "数据加载中..."
            });
            this.$axios
                .get(this.baseUrl3 + "app/findAll")
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        data.forEach((obj, index) => {
                            obj.index = index
                            // 菜单总个数
                            obj.len = data.length
                            // 父菜单的id
                            obj.uiParent = null
                            if(obj.childrenList && obj.childrenList.length > 0){
                                obj.childrenList.forEach((child, childIndex) => {
                                    child.index = childIndex
                                    // 子菜单总个数
                                    child.len = obj.childrenList.length
                                    child.uiParent = obj.id
                                })
                            }
                        })
                        this.tables = data
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                    loading.close();
                })
                .catch(error => {
                    loading.close();
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        addMenu(){
            this.showMenuAdd = true
            this.selectMenu = null
        },
        menu_submenuAdd(row){
        // addChildMenu(row){
            this.selectMenu = {
                parentId: row.id,
                menuList: this.tables,
                type: 'addChild'
            }

            this.parentId = row.id


            this.showMenuAdd = true
        },
        menu_edit(row){
        // app_edit(row){
            this.selectMenu = row
            this.selectMenu.menuList = this.tables
            this.selectMenu.type = 'edit'
            this.showMenuAdd = true
        },
        del(row){
            this.$axios
                .get(this.baseUrl3 + "app/del/" + row.id)
                .then(({ data: { msg, data, code } }) => {
                    if (code == 20000) {
                        this.$message.success('操作成功')
                        this.getList()
                    } else {
                        this.$message({ showClose: true, message: msg, type: "error" });
                        console.log(msg);
                    }
                })
                .catch(error => {
                    this.$message({
                        showClose: true,
                        message: "系统异常",
                        type: "error"
                    });
                    console.log(error);
                });
        },
        menu_del(row){
        // delConfirm(row){
            this.$confirm('您确认要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(row)
            }).catch(() => {

            });
        },
        menuAddCallback(val){
            if(val){
                this.getList()
            }
            this.showMenuAdd= false
        },
        // 点击菜单显示该菜单下的操作
        showOperation(row, index){
            this.currentRowIndex = index
            this.$emit('clickMenuCallback', row)
        },


    }
}
</script>
<style scoped>
#menulist >>> .success-row {
    background: #e1f7d4;
  }
.btnList:last-child{
      margin-top: 6px;
  }
</style>
